import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Fieldset } from "primereact/fieldset";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputSwitch } from "primereact/inputswitch";
//services
import { getFormLeadConfig } from "../../../services/Crm/Settings/FormLead/getFormLeadConfig";
import { postFormLeadConfig } from "../../../services/Crm/Settings/FormLead/postFormLeadConfig";
//hooks
import usePermission from "../../../hooks/usePermission";
//context
import { useAppContext } from "../../../context/AppContext";

export const FormLeadConfig = () => {
  usePermission("258");
  const { permissions } = useAppContext();
  const [formLeadData, setFormLeadData] = useState(null);
  const [checkedFields, setCheckedFields] = useState([]);
  const nameMapping = {
    name: "Nome",
    email: "E-mail",
    phone: "Telefone",
    origin_id: "Origem",
    enterprise_id: "Empreendimento",
    team_id: "Time",
    broker_id: "Corretor",
    obs: "Observação",
    address: "Endereço",
    cep: "CEP",
    numero: "Número",
    complement: "Complemento",
    city: "Cidade",
    state: "Estado",
    neighborhood: "Bairro",
  };

  const items = [
    {
      template: () => (
        <Link
          to={`/settings/generalAddressConfiguration`}
          className="p-breadcrumb-link"
        >
          Obrigatoriedades Cadastro de Lead
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: formLead, isLoading: isLoadingFormLead } = useQuery({
    queryKey: [`formLead`],
    queryFn: () => getFormLeadConfig(),
  });

  useEffect(() => {
    if (formLead) {
      setFormLeadData({
        basicInfo: formLead.fields.filter((field) => field.type === 1),
        addressInfo: formLead.fields.filter((field) => field.type === 2),
      });
      setCheckedFields(formLead.required);
    }
  }, [formLead]);

  const toggleChecked = (field) => {
    setCheckedFields((prevCheckedFields) => {
      const isFieldChecked = prevCheckedFields.some(
        (item) => item.name === field.name && item.type === field.type
      );

      if (isFieldChecked) {
        return prevCheckedFields.filter(
          (item) => !(item.name === field.name && item.type === field.type)
        );
      } else {
        return [...prevCheckedFields, field];
      }
    });
  };

  const handleSave = async () => {
    const formattedCheckedFields = checkedFields.map((field) => ({
      name: field.name,
      type: field.type,
    }));
    const notification = toast.loading(
      "Salvando as informações, por favor aguarde..."
    );
    try {
      await postFormLeadConfig(formattedCheckedFields);
      toast.update(notification, {
        render: "Informações salvas com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao salvar as informações!",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-6">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-xl-6 text-end">
          {permissions?.includes("259") && (
            <Button
              rounded
              label="Salvar"
              icon="fa fa-save"
              className="p-inputtext-sm m-auto"
              onClick={handleSave}
            />
          )}
        </div>
      </div>
      {isLoadingFormLead ? (
        <Skeleton width="100%" height={400} />
      ) : (
        <>
          <Fieldset
            className="mt-2"
            legend={
              <div className="text-start d-flex justify-content-start text-success py-3">
                <span className="pi pi-user mx-2"></span>
                <h4>Informações Básicas</h4>
              </div>
            }
          >
            <div className="row">
              {formLeadData?.basicInfo.map((field) => (
                <div
                  key={field.name}
                  className={`${
                    window.innerWidth <= 992 ? "col-6" : "col-3"
                  } py-2`}
                >
                  <p className="m-auto pb-2">
                    {nameMapping[field.name] || field.name}
                  </p>
                  <InputSwitch
                    checked={checkedFields.some(
                      (item) =>
                        item.name === field.name && item.type === field.type
                    )}
                    onChange={() => toggleChecked(field)}
                  />
                </div>
              ))}
            </div>
          </Fieldset>
          <Fieldset
            className="mt-2"
            legend={
              <div className="text-start d-flex justify-content-start text-success py-3">
                <span className="pi pi-user mx-2"></span>
                <h4>Endereço</h4>
              </div>
            }
          >
            <div className="row">
              {formLeadData?.addressInfo.map((field) => (
                <div
                  key={field.name}
                  className={`${
                    window.innerWidth <= 992 ? "col-6" : "col-3"
                  } py-2`}
                >
                  <p className="m-auto pb-2">
                    {nameMapping[field.name] || field.name}
                  </p>
                  <InputSwitch
                    checked={checkedFields.some(
                      (item) =>
                        item.name === field.name && item.type === field.type
                    )}
                    onChange={() => toggleChecked(field)}
                  />
                </div>
              ))}
            </div>
          </Fieldset>
        </>
      )}
    </>
  );
};
